import React, { useContext, useState, useEffect } from 'react';
import Cookies from "js-cookie";
import { AuthContext } from "../util/context";
import { withRouter } from 'react-router-dom';

const Logout = () => {

  const { token, userData, setAuth } = useContext(AuthContext);

  useEffect(() => {
    localStorage.removeItem("auth_token");
    Cookies.remove("token");
    Cookies.remove("userData");
    setAuth();

    // session delete, or inactive
    goBackHome()
  }, []);

  const goBackHome = () => {
    // const url = `/`;
    // this.props.history.push(url);
    const url = "http://" + window.location.host + "/listings"
    window.location = url
    return false;
  }

  return (
    <div className="">
    </div>
  )
}

export default withRouter(Logout);
